export default "__VITE_ASSET__Dt7B5SYD__"